import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgStar = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path d="M21.284 8.275l-5.951-.865-2.66-5.393a.753.753 0 00-1.345 0L8.667 7.41l-5.952.865a.749.749 0 00-.414 1.28l4.305 4.197-1.017 5.927a.749.749 0 001.087.79L12 17.671l5.323 2.798a.749.749 0 001.087-.79l-1.017-5.927 4.305-4.198a.748.748 0 00.218-.429.747.747 0 00-.632-.85z" />
    </Icon>
  );
};

export default SvgStar;
